import elements from '../store/elements'

const doc = document
const outsideBtnWrapper = elements.form.querySelector('.outside-wrapper-product-button')
const stickyBreakpoint = 1200
let btnSticky = false

const addButton = () => {
// Sticky button for mobile
  if (window.matchMedia(`(max-width: ${stickyBreakpoint}px)`).matches) {
    const observer = new global.IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (btnSticky) {
            outsideBtnWrapper.classList.remove('add-button--sticky')
            outsideBtnWrapper.style.height = ''
            btnSticky = false
            // hide help center btn
            doc.querySelector('.fixed-help__container')?.removeAttribute('hidden')
            // hide welcome popup reminder
            doc.querySelector('.ft-pop__reminder')?.removeAttribute('hidden')
          }
        } else {
          if (!btnSticky && outsideBtnWrapper.getBoundingClientRect().bottom < 0) {
            outsideBtnWrapper.style.height = outsideBtnWrapper.offsetHeight + 'px'
            outsideBtnWrapper.classList.add('add-button--sticky')
            btnSticky = true
            // show help center btn
            doc.querySelector('.fixed-help__container')?.setAttribute('hidden', '')
            // show welcome popup reminder
            doc.querySelector('.ft-pop__reminder')?.setAttribute('hidden', '')
          }
        }
      })
    })
    observer.observe(outsideBtnWrapper)
  }
}

export default addButton
